export default "__VITE_ASSET__D_GfE7Tp__"